/**
 * Shared auth route/path constants to avoid duplication across the app.
 *
 * Important distinction:
 * - UI routes: client-side routes like `/auth/login`
 * - API paths: server endpoints that include `/auth/...` in their URL path
 */

// Public (guest) pages in the UI auth area
export const PUBLIC_AUTH_UI_ROUTES = [
  "/auth/login",
  "/auth/signup",
  "/auth/forgotPassword",
  "/auth/reset-password",
] as const;

// Public auth API endpoints that should NOT receive an Authorization header
export const PUBLIC_AUTH_API_PATHS = [
  "/auth/logout",
  "/auth/login",
  "/auth/register",
  "/auth/restore-password",
  "/auth/reset-password",
  "/auth/refresh-token",
] as const;

// Paths that should NOT trigger the global 401 auto-logout handler.
// Verification routes are excluded because SESSION_EXPIRED 401s are handled
// explicitly in the auth store actions (with user-facing messaging) rather
// than being silently swallowed by the global interceptor.
export const AUTO_LOGOUT_401_EXCLUDED_PATHS = [
  ...PUBLIC_AUTH_API_PATHS,
  "/404",
  "verification/",
] as const;
